var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE3\x83\x9B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stroke 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill",
    d: "M44.288 31.872L48.64 29.568C52.032 33.664 57.152 41.664 59.712 46.272L54.976 48.896C52.416 43.904 47.616 35.904 44.288 31.872Z",
    fill: "black",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace",
    d: "M46 30C50.8885 36.6529 53.8219 40.9777 57.5 48",
    stroke: "#FF0000",
    strokeOpacity: 0.5,
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Stroke 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_2",
    d: "M17.408 29.504L21.888 31.68C19.136 37.184 13.184 45.312 9.53599 49.28L5.18399 46.272C9.40799 42.304 14.912 34.688 17.408 29.504Z",
    fill: "black",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace_2",
    d: "M20 30C15.7444 37.3892 12.8165 41.6661 7 48",
    stroke: "#FF0000",
    strokeOpacity: 0.5,
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Stroke 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_3",
    d: "M35.904 5.82397H29.952C30.144 6.78397 30.4 9.02398 30.4 10.368C30.4 13.76 30.4 20.096 30.4 22.272C30.4 25.344 30.4 47.168 30.4 50.688C30.336 52.352 29.632 53.12 27.904 53.12C26.176 53.12 23.296 52.864 20.48 52.352L20.928 57.472C23.552 57.728 27.328 57.92 30.08 57.92C33.92 57.92 35.52 56.192 35.52 52.8C35.52 48.256 35.52 27.52 35.52 22.272C35.52 19.2 35.52 13.824 35.52 10.432C35.52 9.02398 35.776 6.71997 35.904 5.82397Z",
    fill: "black",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace_3",
    d: "M33 5.5C33 46.5 33.5 53 32 54.5C30.5 56 27 55.5 19.5 54.5",
    stroke: "#FF0000",
    strokeOpacity: 0.5,
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Stroke 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    d: "M7.168 22.016V16.64C8.96 16.832 10.56 16.96 12.608 16.96H52.48C53.952 16.96 56.128 16.896 57.664 16.64V21.952C56 21.824 54.08 21.824 52.544 21.824H12.608C10.688 21.824 8.832 21.888 7.168 22.016Z",
    fill: "black",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace_4",
    d: "M7 19.5H58",
    stroke: "#FF0000",
    strokeOpacity: 0.5,
    strokeWidth: 7
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHo);
export default __webpack_public_path__ + "static/media/ho.4d3c0f0f29195c68db085eac07f51d31.svg";
export { ForwardRef as ReactComponent };